import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteSupplierCreate,
  NoteSupplierCreateVariables,
} from 'settings/account/supplier/view/ActionMenu/SupplierNotes/__generated__/NoteSupplierCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_TRANSACTION_CREATE from '../../../../../../settings/account/supplier/view/ActionMenu/SupplierNotes/NoteSupplierCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  id,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      NoteSupplierCreate, // TMutationResult
      NoteSupplierCreateVariables // TMutationVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_TRANSACTION_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
